

export default {
  props: {
    diagramIds: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: () => ({
    specialOffers: []
  }),
  async fetch () {
    const offers = await this.$backend.specialOffers.get({ diagram_ids: this.diagramIds.join(',') })

    this.specialOffers = offers.reduce((unique, offer) => {
      if (this.isUniqueOffer(offer, unique)) {
        unique.push(offer)
      }
      return unique
    }, [])
  },
  computed: {
    specialOfferClasses () {
      if (this.specialOffers.length > 1) {
        return 'lg:grid-cols-2 grid-cols-1'
      } else {
        return 'flex'
      }
    }
  },
  methods: {
    isUniqueOffer (offer, existingOffers) {
      return !existingOffers.some(existing =>
        existing.id === offer.id ||
        existing.diagram.id === offer.diagram.id
      )
    }
  }
}

